import { render, staticRenderFns } from "./DPEnviromentTableMenu.vue?vue&type=template&id=04f6c0d3&scoped=true&"
import script from "./DPEnviromentTableMenu.vue?vue&type=script&lang=js&"
export * from "./DPEnviromentTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f6c0d3",
  null
  
)

export default component.exports